import { ObservableArray, View } from "binder"
import { DistrictTransferViewModel } from "./districtTransfer-viewModel"
import { IRequest } from "./IRequest";

export class DistrictTransferView extends View<DistrictTransferViewModel>{
    GetViewUniqueId(): string {
        return "V-5F970758-812F-42B9-AA9A-FB5802C57E74"
    }
    loadHtml(): string {
        let element = require('./districtTransfer.html').default;
        let style = require('./districtTransfer.less');
        return element;
    }
    constructor() {
       super();
    }

    public set items(v: ObservableArray<IRequest>) { this._items = v; } public get items(): ObservableArray<IRequest> { return this._items;} private _items: ObservableArray<IRequest>;
    public set selectedItem(v: IRequest) { this._selectedItem = v; } public get selectedItem(): IRequest { return this._selectedItem;} private _selectedItem: IRequest;

}
